export const EMPLOYMENT_TYPES = [
  { value: 'full_time', label: 'Full-time' },
  { value: 'intern', label: 'Intern' },
];

export const INITIAL_FORM_STATE = {
  userName: '',
  email: '',
  userRoleId: undefined,
  clientName: undefined,
  employmentType: 'full_time',
};

export const ADD_CLIENT_FORM_TITLE = 'Add a New User';

export const EDIT_CLIENT_FORM_TITLE = 'Edit a User';

export const boldHeader = (color) => (table) => <b style={{ color }}>{table?.column?.columnDef?.header}</b>;

export const USER_LIST_TABLE_COLUMNS = [
  {
    accessorKey: 'userName',
    header: 'Name',
    Header: boldHeader('#454F5B'),
    size: 50,
    Cell: ({ cell }) => <span style={{ textTransform: 'capitalize' }}>{cell.getValue()}</span>,
  },
  {
    accessorKey: 'email',
    header: 'Email',
    Header: boldHeader('#454F5B'),
    size: 100,
  },
  {
    accessorKey: 'userRoles.roleName',
    header: 'Role',
    Header: boldHeader('#454F5B'),
    size: 50,
    Cell: ({ cell }) => <span style={{ textTransform: 'capitalize' }}>{cell.getValue()}</span>,
  },
  {
    accessorKey: 'employmentType',
    header: 'Employment Type',
    Header: boldHeader('#454F5B'),
    enableColumnFilter: false,
    size: 60,
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return (
        <span
          style={{
            padding: '2px 10px',
            borderRadius: 12,
            fontSize: '0.75rem',
            fontWeight: 600,
            background: value === 'intern' ? '#FFF3CD' : '#D0E8FF',
            color: value === 'intern' ? '#B76E00' : '#1877F2',
          }}
        >
          {value === 'intern' ? 'Intern' : 'Full-time'}
        </span>
      );
    },
  },
  {
    accessorKey: 'totalPoints',
    header: 'Score',
    Header: boldHeader('#454F5B'),
    enableColumnFilter: false,
    size: 50,
  },
];

export const USER_LIST_TABLE_DEFAULT_PROPS = {
  positionActionsColumn: 'last',
  enableFullScreenToggle: false,
  enableColumnActions: false,
  manualPagination: true,
  manualFiltering: true,
  manualSorting: true,
  muiTablePaperProps: {
    sx: {
      color: 'rgb(71 85 105 / var(--tw-text-opacity))',
    },
  },
  muiTopToolbarProps: {
    sx: {
      backgroundColor: '#fff',
    },
  },
  muiTableHeadRowProps: {
    sx: {
      '--tw-bg-opacity': 1,
      backgroundColor: 'rgb(226 232 240 / var(--tw-bg-opacity))',
      fontWeight: '900',
    },
  },
  muiTableHeadCellFilterTextFieldProps: {
    sx: {
      m: '0.5rem 0',
      borderColor: 'white',
      '& input': {
        borderColor: 'white',
        '&::placeholder': {
          color: 'white',
        },
      },
      '& .MuiInput-root:before, &.MuiInputBase-root:before': {
        borderBottomColor: 'white',
        color: 'white',
      },
      '& .MuiInputBase-input, &.MuiButtonBase-root, &.MuiIconButton-root': {
        textTransform: 'capitalize',
        color: 'white',
      },
    },
  },
  muiTableHeadCellProps: {
    sx: {
      backgroundColor: '#F9FAFB',
      fontWeight: '800',
      fontSize: '.75rem',
      lineHeight: '2rem',
      textTransform: 'uppercase',
      paddingRight: '1.5rem',
      paddingLeft: '1.5rem',
    },
  },
  muiTableBodyCellProps: {
    sx: {
      paddingLeft: '1.5rem',
    },
  },
};
